import DistincBlocks from "./DistincBlocks";

export default DistincBlocks;
